enum TicketType {
  entry = 'Вхідний квиток',
  excursion = 'Екскурсія',
}

export default TicketType;
